import { Outlet, RouteObject } from 'react-router-dom';

import projectDetailsWizardRoutes from './project-details-wizard/project-details-wizard.routes';
import ChooseTemplateRootView from './choose-template-root.view';
import chooseTemplateLoader from './choose-template.loader';
import RouteGuard from '@ui/route-guard/route-guard';
import { getLeavePlatformLink } from '@/utils/navigation/get-leave-platform-link';

const ChooseTemplateRouteGuard = () => {
  const leavePlatformLink = getLeavePlatformLink();

  return (
    <RouteGuard
      allowedRoles={[]}
      redirectTo={leavePlatformLink}
      unauthorizedMessage="Sorry, you don't have permission to view this content. If you think this is a mistake, please contact your admin."
    >
      <ChooseTemplateRootView />
    </RouteGuard>
  );
};

const ChooseTemplateRoutes: RouteObject[] = [
  {
    path: '*',
    id: 'choose-template-root',
    element: <ChooseTemplateRouteGuard />,
    shouldRevalidate: () => false,
    children: [
      {
        index: true,
        id: 'choose-template-catch-all',
        loader: chooseTemplateLoader,
        shouldRevalidate: () => false,
        async lazy() {
          const ChooseTemplate = await import('./choose-template/choose-template.view');
          return { Component: ChooseTemplate.default };
        },
      },
      {
        path: 'preview-template/:projectUuid',
        id: 'preview-template',
        shouldRevalidate: () => false,
        async lazy() {
          // const PreviewTemplate = await import('./preview-template/preview-template-original-designs.view');
          const PreviewTemplate = await import('./preview-template/preview-template.view');
          return { Component: PreviewTemplate.default };
        },
      },
      {
        path: 'project-details/wizard/:templateId',
        id: 'project-details/wizard/:templateId',
        element: <Outlet />,
        children: projectDetailsWizardRoutes,
      },
    ],
  },
];

export default ChooseTemplateRoutes;
